import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocialModule } from '../social';
import { CommonModule as NimbusCommonModule } from '../common/common.module';

import { WorkspaceSelectComponent } from './workspace-select.component';
import { WorkspaceSelectItemComponent } from './workspace-select-item.component';

@NgModule({
  providers: [

  ],
  declarations: [
    WorkspaceSelectComponent,
    WorkspaceSelectItemComponent,
  ],
  imports: [
    CommonModule,
    NimbusCommonModule,
    SocialModule,
  ],
  exports: [
    WorkspaceSelectComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WorkspacesModule { }